import { Directive, forwardRef } from '@angular/core';
import { debounceTime, distinctUntilChanged, Observable, of, startWith, take } from 'rxjs';
import { AbstractControl, AsyncValidator, NG_ASYNC_VALIDATORS, ValidationErrors } from '@angular/forms';
import { EMAIL_REG_EXP } from '@root/app.config';
import { catchError, map, switchMap } from 'rxjs/operators';

@Directive({
	selector: '[appValidateEmail]',
	providers: [
		{
			provide: NG_ASYNC_VALIDATORS,
			useExisting: forwardRef(() => InputEmailValidator),
			multi: true,
		},
	],
})
export class InputEmailValidator implements AsyncValidator {
	constructor() {}

	validate(control: AbstractControl): Promise<ValidationErrors | null> | Observable<ValidationErrors | null> {
		const changes$ = control.valueChanges ? control.valueChanges.pipe(startWith(control.value)) : of(control.value);

		return changes$.pipe(
			debounceTime(1000),
			distinctUntilChanged(),
			take(1),
			switchMap((value) => this.checkEmail(value)),
			map((isValid) => (isValid ? null : { email: true })),
			catchError(() => of(null)),
		);
	}

	private checkEmail(value: string): Observable<boolean> {
		return of(EMAIL_REG_EXP.test(value.trim()));
	}
}
